import WhatsAppEventModal from './WhatsAppEventModal';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tramite: any;
};

const WhatsAppOtroTramiteRetiroModal = ({ open, onOpenChange, tramite }: Props) => {
  return (
    <WhatsAppEventModal
      open={open}
      onOpenChange={onOpenChange}
      tramite={tramite}
      eventType="otros_tramites.documentacion_lista_retiro"
      title="Enviar aviso de retiro por WhatsApp"
      description="Se enviará una notificación para retirar la documentación en oficina."
      contextOverrides={{
        otro_tramite_id: tramite.id,
        tramite_id: tramite.id,
      }}
    />
  );
};

export default WhatsAppOtroTramiteRetiroModal;
